import { XMarkIcon } from "@heroicons/react/24/outline";
import type { UseFormReturn } from "react-hook-form";
import type { RecipesFilterFormValues } from "../RecipesFilterContainer";
import { FavoriteChip, MadeItChip, RecipeCategoryChip, RecipeTypeChip } from "@/components/chips";

interface ActiveFilterChipsProps {
    form: UseFormReturn<RecipesFilterFormValues>;
    hasFixedType?: boolean;
    onChange(): void;
    onClearAll(): void;
}

export const ActiveFilterChips = ({ form, hasFixedType, onChange, onClearAll }: ActiveFilterChipsProps) => {
    const values = form.watch();

    const removeType = (name: string) => {
        form.setValue(
            "recipeTypeNames",
            values.recipeTypeNames.filter((t) => t !== name)
        );
        onChange();
    };

    const removeCategory = (name: string) => {
        form.setValue(
            "recipeCategoryNames",
            values.recipeCategoryNames.filter((c) => c !== name)
        );
        onChange();
    };

    const clearMadeIt = () => {
        form.setValue("hasMadeIt", ["any"]);
        onChange();
    };

    const clearFavorite = () => {
        form.setValue("isFavorite", false);
        onChange();
    };

    const typeChips = !hasFixedType ? values.recipeTypeNames : [];
    const madeIt = values.hasMadeIt?.[0];
    const showMadeIt = madeIt && madeIt !== "any";

    const total =
        typeChips.length + values.recipeCategoryNames.length + (showMadeIt ? 1 : 0) + (values.isFavorite ? 1 : 0);

    if (total === 0) return null;

    return (
        <div className="w-full flex flex-wrap justify-center gap-2 mt-5">
            {typeChips.map((name) => (
                <RecipeTypeChip key={`type-${name}`} name={name} onRemove={() => removeType(name)} />
            ))}
            {values.recipeCategoryNames.map((name) => (
                <RecipeCategoryChip key={`cat-${name}`} name={name} onRemove={() => removeCategory(name)} />
            ))}
            {showMadeIt && (
                <MadeItChip state={madeIt === "true" ? "made" : "not-tried"} onRemove={clearMadeIt} />
            )}
            {values.isFavorite && <FavoriteChip onRemove={clearFavorite} />}
            <button
                type="button"
                onClick={onClearAll}
                className="inline-flex items-center gap-1 self-center ml-2 px-1 bg-transparent border-0 text-[17px] font-medium text-[var(--fg-2)] cursor-pointer transition-colors hover:text-[var(--color-primary)] hover:underline hover:underline-offset-[3px]"
            >
                <XMarkIcon className="w-3.5 h-3.5" />
                Clear all
            </button>
        </div>
    );
};
